import React from 'react';
import {Icon} from 'antd';
import {Link} from 'react-router-dom';

import i18n from '../../../../i18n';
import InstructionLayout from '../instruction-layout';


const instructions = [
    {
        type: 'pdf',
        href: '/instructions/Инструкция для грузовладельцев.pdf',
        titleKey: 'forConsignor',
        description:
            'Общая инструкция по работе на платформе для грузовладельцев.',
        format: 'PDF',
        icon: 'team',
    },
    {
        type: 'pdf',
        href: '/instructions/Инструкция для перевозчиков.pdf',
        titleKey: 'forCarrier',
        description:
            'Общая инструкция по работе на платформе для перевозчиков.',
        format: 'PDF',
        icon: 'car',
    },
    {
        type: 'page',
        to: '/service/edo',
        title: 'ЭДО',
        description:
            'Подключение электронного документооборота и отправка документов.',
        format: 'Страница',
        icon: 'file-text',
    },
    {
        type: 'page',
        to: '/service/notifications',
        title: 'Уведомления',
        description:
            'Настройка получения уведомлений и выбор распределительных центров.',
        format: 'Страница',
        icon: 'bell',
    },
    {
        type: 'page',
        to: '/service/time-windows',
        title: 'Временные окна',
        description:
            'Запись на погрузку, расписание склада и действия водителя.',
        format: 'Страница',
        icon: 'clock-circle',
    },
    {
        type: 'page',
        to: '/service/legal-entity-disagreement',
        title: 'Действия в случае несогласования',
        description:
            'Что делать после отказа в согласовании юридического лица.',
        format: 'Страница',
        icon: 'solution',
    },
    {
        type: 'page',
        to: '/service/vehicle-inspection',
        title: 'Проверка ТС и водителя',
        description:
            'Проверка транспортного средства, прицепа и водителя перед погрузкой.',
        format: 'Страница',
        icon: 'camera',
    },
    {
        type: 'page',
        to: '/service/vat',
        title: 'НДС',
        description:
            'Выбор способа работы с НДС и загрузка подтверждающих документов.',
        format: 'Страница',
        icon: 'calculator',
    },
    {
        type: 'page',
        to: '/service/partners',
        title: 'Партнёры',
        description:
            'Поиск перевозчиков, согласование контрагентов и работа с договорами.',
        format: 'Страница',
        icon: 'team',
    },
    {
        type: 'page',
        to: '/service/contract-termination',
        title: 'Расторжение договора',
        description:
            'Запуск расторжения договора, загрузка подписанного соглашения и финальное согласование.',
        format: 'Страница',
        icon: 'close-circle',
    },
    {
        type: 'page',
        to: '/service/goslog-vital-approval',
        title: 'Согласование ГосЛог у "Витал"',
        description:
            'Подтверждение регистрации экспедитора в ГосЛог и проверка статуса заявки.',
        format: 'Страница',
        icon: 'audit',
    },
    {
        type: 'page',
        to: '/service/bid-submission',
        title: 'Подача ставок',
        description:
            'Подача заявки на рейс, изменение условий и работа со встречными предложениями.',
        format: 'Страница',
        icon: 'swap',
    },
];

const sortedInstructions = [...instructions].sort((a, b) => {
    if (a.type !== b.type) {
        return a.type === 'pdf' ? -1 : 1;
    }

    const firstTitle = a.title || i18n.t(
        `main.instructions.${a.titleKey}`
    );

    const secondTitle = b.title || i18n.t(
        `main.instructions.${b.titleKey}`
    );

    return firstTitle.localeCompare(
        secondTitle,
        'ru',
        {
            sensitivity: 'base'
        }
    );
});

export default function Instruction() {
    return (
        <InstructionLayout title="Инструкции">
            <p className="instruction-intro">
                Здесь собраны инструкции по основным возможностям платформы.
                Раздел будет дополняться новыми материалами.
            </p>

            <div className="instruction-catalog">
                {sortedInstructions.map((instruction) => {
                    const title = instruction.title || i18n.t(
                        `main.instructions.${instruction.titleKey}`
                    );

                    const content = (
                        <>
                            <div className="instruction-card__header">
                                <span className="instruction-card__icon">
                                    <Icon type={instruction.icon}/>
                                </span>

                                <span className="instruction-card__format">
                                    {instruction.format}
                                </span>
                            </div>

                            <div className="instruction-card__content">
                                <h2 className="instruction-card__title">
                                    {title}
                                </h2>

                                <p className="instruction-card__description">
                                    {instruction.description}
                                </p>
                            </div>

                            <span className="instruction-card__action">
                                {instruction.to ? 'Открыть' : 'Скачать'}

                                <Icon
                                    type={instruction.to ? 'right' : 'download'}
                                />
                            </span>
                        </>
                    );

                    if (instruction.to) {
                        return (
                            <Link
                                className="instruction-card"
                                key={instruction.to}
                                to={instruction.to}
                            >
                                {content}
                            </Link>
                        );
                    }

                    return (
                        <a
                            className="instruction-card"
                            key={instruction.href}
                            href={instruction.href}
                            download
                        >
                            {content}
                        </a>
                    );
                })}
            </div>
        </InstructionLayout>
    );
}